import { useId, type ChangeEvent } from "react";
import type { Currency } from "@/api/types";
import "./currency-picker.css";

const OPTIONS: ReadonlyArray<{ value: Currency; label: string }> = [
  { value: "UAH", label: "UAH · ₴" },
  { value: "EUR", label: "EUR · €" },
  { value: "USD", label: "USD · $" },
  { value: "PLN", label: "PLN · zł" },
];

export interface CurrencyPickerProps {
  label: string;
  value: Currency;
  onChange: (next: Currency) => void;
  disabled?: boolean;
  hint?: string;
  id?: string;
}

export function CurrencyPicker({
  label,
  value,
  onChange,
  disabled,
  hint,
  id,
}: CurrencyPickerProps) {
  const autoId = useId();
  const selectId = id ?? autoId;

  function handleChange(e: ChangeEvent<HTMLSelectElement>) {
    onChange(e.currentTarget.value as Currency);
  }

  return (
    <div className="wp-ccy">
      <label htmlFor={selectId} className="wp-ccy__label">
        {label}
      </label>
      <div className="wp-ccy__field">
        <select
          id={selectId}
          className="wp-ccy__select"
          value={value}
          onChange={handleChange}
          disabled={disabled}
        >
          {OPTIONS.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
        <span aria-hidden="true" className="wp-ccy__caret">
          ▾
        </span>
      </div>
      {hint ? <p className="wp-ccy__hint">{hint}</p> : null}
    </div>
  );
}
